import React from 'react'
import "../../styles/tituloImpuestosMunicipales.css"

function TituloImpuestosMunicipales() {
  return (
    <div className='logo-text-impuestos'>____Expertos__en__impuestos__municipales____</div>
  )
}

export default TituloImpuestosMunicipales